var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMineicon7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.16667 15.3099H15.8333V9.36736C15.8333 6.05627 13.2217 3.37193 10 3.37193C6.77833 3.37193 4.16667 6.05627 4.16667 9.36736V15.3099ZM10 1.6665C14.1417 1.6665 17.5 5.11402 17.5 9.36736V17.0153H2.5V9.36736C2.5 5.11402 5.85833 1.6665 10 1.6665ZM7.91667 17.8681H12.0833C12.0833 18.4334 11.8638 18.9757 11.4731 19.3755C11.0824 19.7752 10.5525 19.9998 10 19.9998C9.44747 19.9998 8.91756 19.7752 8.52686 19.3755C8.13616 18.9757 7.91667 18.4334 7.91667 17.8681Z",
    fill: "#09121F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMineicon7);
export default __webpack_public_path__ + "static/media/mineicon7.e260938d8586d772d932290a5828d8e2.svg";
export { ForwardRef as ReactComponent };